
import * as actionTypes from "../constants/actionTypes";

export interface SelectCategoryAction {
  type: "SELECT_CATEGORY";
  payload: {
    id: string;
    values: Array<string>;
    children: Array<string>;
  };
}

export type Action = SelectCategoryAction;

export function selectCategory(
  id: string,
  values: Array<string>,
  children: Array<string>
): Action {
  return {
    type: actionTypes.SELECT_CATEGORY,
    payload: {
      id,
      values,
      children
    }
  };
}
